
export enum PROSPECT_API_ENUM {
  PROSPECT = '/cmcrst/x-services/prospect',
  GET_PROSPECT = '/cmcrst/x-services/getprospects',
  PROSPECT_STATUS_UPDATE = '/cmcrst/x-services/prospect/prospectupdate',
  UNSECURED_PROSPECT = '/cmcrst/x-services/prospect/public',
  PROSPECT_STATUS = '/cmcrst/x-services/prospect/status',

  CREATE_FFM_PROSPECT = '/cmcrst/x-services/prospect',
  INDIVIDUAL_GET_ON_EXCHANGE_STATUSES = '/cmcrst/x-services/prospect',
  INDIVIDUAL_GET_ON_EXCHANGE_STATUS_UPDATE_GEN_ADMIN = '/cmcrst/x-services/prospect',

  INDIVIDUAL_UPDATE_ON_EXCHANGE_STATUS = '/cmcrst/x-services/prospect/prospectupdate',

  CREATE_BLANK_APP_PROSPECT = '/cmcrst/x-services/prospect/public',
  UPDATE_BLANK_APP_PROSPECT = '/cmcrst/x-services/prospect/public',

  INDIVIDUAL_GET_ON_EXCHANGE_STATUS_UPDATE = '/cmcrst/x-services/prospect/status',

  PRODUCER_ACTIVE_APPS = '/cmcrst/x-services/prospect',
  PRODUCER_COMPLETED_APPS = '/cmcrst/x-services/prospect/status/enroll',
  PRODUCER_EXPIRED_APPS = '/cmcrst/x-services/prospect/status/expire',
  PROUDUCER_EMAILED_APPS = '/cmcrst/x-services/prospect/status/emailed',
  PROUDUCER_ARCHIVED_APPS = '/cmcrst/x-services/prospect/status/archive'
}
